<div class="bg-white p-3 border-round" style="border: 1px solid var(--surface-d)">
  <div class="flex flex-row justify-content-between">
    <h4 class="text-primary text-lg">{{ title }}</h4>
    @if (form.controls.coverageAmount.value || form.controls.duration.value) {
      <span class="pi pi-undo cursor-pointer text-xl" (click)="resetProduct()"></span>
    }
  </div>
  <div>
    <div class="flex flex-row justify-content-between">
      <div class="w-6 flex flex-row gap-3">
        <div class="w-full">
          <label i18n
            >Montant
            @if (titleTooltip) {
              <span
                [pTooltip]="titleTooltip"
                tooltipPosition="top"
                hideDelay="500"
                class="pi pi-info-circle pb-1"></span>
            }
          </label>
          <p-dropdown
            [options]="_coverageAmountOptions"
            [filter]="true"
            [virtualScroll]="(_coverageAmountOptions?.length ?? 0) > 500"
            [virtualScrollItemSize]="15"
            [formControl]="form.controls.coverageAmount"
            filterBy="value,name"
            filterMatchMode="startsWith"
            i18n-placeholder
            placeholder="Choisir"
            optionLabel="name"
            optionValue="value"></p-dropdown>
        </div>

        @if (_durationOptions) {
          <div class="w-full">
            <label i18n
              >Durée
              @if (durationTooltip) {
                <span
                  [pTooltip]="durationTooltip"
                  tooltipPosition="top"
                  hideDelay="500"
                  class="pi pi-info-circle pb-1"></span>
              }
            </label>
            <p-dropdown
              [options]="_durationOptions"
              [formControl]="form.controls.duration"
              i18n-placeholder
              placeholder="Choisir"
              optionLabel="name"
              optionValue="value">
              <ng-template let-item pTemplate="item">
                {{ item.name }}
              </ng-template>
              <ng-template let-selectedItem pTemplate="selectedItem">
                @if (productType === 'WHOLE' || productType === 'TERM') {
                  {{ selectedItem.value }}
                } @else {
                  {{ selectedItem.name }}
                }
              </ng-template>
            </p-dropdown>
          </div>
        } @else {
          <div class="w-full"></div>
        }
      </div>
    </div>

    <div class="flex flex-row">
      <p-divider class="w-full"></p-divider>
      @if (isPriceLoading) {
        <p-progressSpinner styleClass="ml-5 w-2rem h-2rem" strokeWidth="4"></p-progressSpinner>
      } @else {
        <div class="ml-5 text-xl font-medium" i18n>
          @if (_price) {
            {{ _price | emAmount }}/mois
          } @else {
            N/A
          }
        </div>
      }
    </div>

    @if (productType === 'TERM' && form.controls.coverageAmount.value) {
      <div (click)="openRenewalPricesDialog()" class="flex cursor-pointer text-sm text-color-secondary w-min">
        <i class="pi pi-eye pr-2"></i>
        <b i18n>Renouvellements</b>
      </div>
    }
  </div>
</div>
